import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

const SECTION_IDS = ['fetch-cart-item-count', 'fetch-cart-drawer-items-count'];
SECTION_IDS.forEach((id) => cart.sections.push(id));

/**
 * @param {string} sectionId
 * @param {string} selector
 * @returns {typeof HTMLElement}
 */
function createCartCountClass(sectionId, selector) {
  // eslint-disable-next-line wc/define-tag-after-class-definition -- class is registered via define() below
  return class CartCount extends HTMLElement {
    #unsubscribers = [];

    connectedCallback() {
      this.#unsubscribers.push(
        ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
          pubsub.subscribe(event, ({ sections }) => this.#renderSection(sections))
        )
      );
    }

    disconnectedCallback() {
      this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
    }

    #renderSection(sections) {
      const html = parseHTML(sections[sectionId]);
      const target = html?.querySelector(selector);
      if (target) this.replaceWith(target);
    }
  };
}

const CartItemCount = createCartCountClass('fetch-cart-item-count', 'cart-item-count');
const CartDrawerItemsCount = createCartCountClass(
  'fetch-cart-drawer-items-count',
  'cart-drawer-items-count'
);

if (!customElements.get('cart-item-count')) {
  customElements.define('cart-item-count', CartItemCount);
}
if (!customElements.get('cart-drawer-items-count')) {
  customElements.define('cart-drawer-items-count', CartDrawerItemsCount);
}
